// router.ts - micro-routeur (history API) : accueil + pages légales.
// Pas de dépendance : quelques routes statiques, le hosting réécrit tout vers
// index.html.
import { useCallback, useEffect, useState } from "react";

export type Path =
  | "/"
  | "/mentions-legales"
  | "/confidentialite"
  | "/cgu"
  | "/cgv";

const KNOWN: Path[] = [
  "/",
  "/mentions-legales",
  "/confidentialite",
  "/cgu",
  "/cgv",
];

function normalize(pathname: string): Path {
  const clean = (pathname.replace(/\/+$/, "") || "/") as Path;
  return KNOWN.includes(clean) ? clean : "/";
}

export function useRoute(): { path: Path; navigate: (to: Path) => void } {
  const [path, setPath] = useState<Path>(() => normalize(window.location.pathname));

  useEffect(() => {
    const onPop = () => setPath(normalize(window.location.pathname));
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const navigate = useCallback((to: Path) => {
    if (to !== normalize(window.location.pathname)) {
      window.history.pushState({}, "", to);
    }
    setPath(to);
    window.scrollTo({ top: 0 });
  }, []);

  return { path, navigate };
}
